// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__fzqTC","dragIcon":"Choice_dragIcon__2Ig44","left":"Choice_left__2H_RY","input":"Choice_input__WESPj"};